import { memo, useEffect, useState, useCallback } from "react";
import Form from "../../components/Form";
import { Typography, Box, Button } from "@mui/material";
import {
    getInspectors,
    getOrganizations,
    getUsersData,
    getInspector,
} from "../../api";
import Spinner from "../../components/Spinner";
import { useSnackbar } from "../../utils/index.js";
import InspectorForm from "../../components/forms/InspectorForm.js";
import useSelectStyles from "../../components/styles/Select.js";

const SelectInspector = () => {
    const [inspectorId, setInspectorId] = useState();
    const [fetchedInspector, setFetchedInspector] = useState();
    const [fetchedInspectors, setFetchedInspectors] = useState([]);
    const [inspectorsDropdownValues, setInspectorsDropdownValues] = useState([]);
    const [fetchedOrganizations, setFetchedOrganizations] = useState([]);
    const [fetchedUsers, setFetchedUsers] = useState([]);
    const [isInspectorSelected, setIsInspectorSelected] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const classes = useSelectStyles();
    const { error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            try {
                const { inspectors } = await getInspectors();
                setFetchedInspectors(inspectors);
                const inspectorsDropdownArr = [];
                for (var inspector of inspectors) {
                    inspectorsDropdownArr.push({ value: `${inspector.lastName} ${inspector.firstName}`, text: `${inspector.lastName} ${inspector.firstName}` });
                }
                setInspectorsDropdownValues(inspectorsDropdownArr);

                const { organizations } = await getOrganizations();
                setFetchedOrganizations(organizations);

                const { users } = await getUsersData();
                setFetchedUsers(users);
            } catch (err) {
                error(err)
            }
        }
    )
    useEffect(() => {
        fetchData();
    }, []);

    const selectFormContent = [
        {
            customType: "dropdown",
            id: "inspector",
            items: inspectorsDropdownValues,
            placeholder: "Ελεγκτής",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ]

    const handleInspectorSelectSubmit = async (values) => {
        setIsLoading(true);
        const selectedInspectorId = fetchedInspectors.find((inspector) => `${inspector.lastName} ${inspector.firstName}` === values.inspector)._id;

        const { success: successCode, inspector, message } = await getInspector(selectedInspectorId);

        if (successCode) {
            if (inspector[0]?.organization) {
                const inspectorsOrganization = fetchedOrganizations.find((organization) => organization._id === inspector[0].organization);
                inspectorsOrganization ? inspector[0].organization = inspectorsOrganization.name : inspector[0].organization = null;
            }

            if (inspector[0].user) {
                const inspectorsUser = fetchedUsers.find((user) => user._id === inspector[0].user);
                inspectorsUser ? inspector[0].user = inspectorsUser.username : inspector[0].user = null;
            }
            setInspectorId(inspector[0]._id);
            setFetchedInspector(inspector[0]);
            setIsInspectorSelected(true);
        } else {
            error(message)
        }

        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    {!isInspectorSelected && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                Επιλέξτε τον Ελεγκτή που σας ενδιαφέρει:
                            </Typography>
                            <Form content={selectFormContent} onSubmit={handleInspectorSelectSubmit} />
                        </>
                    )}
                    {isInspectorSelected && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                Επεξεργασία Ελεγκτή
                            </Typography>
                            <InspectorForm
                                isCreate={false}
                                fetchedInspector={fetchedInspector}
                                setFetchedInspector={setFetchedInspector}
                                inspectorId={inspectorId}
                                setIsInspectorSelected={setIsInspectorSelected}
                            />
                            <Button
                                onClick={() => setIsInspectorSelected(false)}
                                sx={{
                                    marginTop: "1rem",
                                    padding: "0.5rem 1rem",
                                    backgroundColor: "third",
                                    color: "secondary.main",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    variant: "h5",
                                }}
                            >
                                Πίσω
                            </Button>
                        </>
                    )}

                </Box>
            </Box>
        </>
    )
}


export default memo(SelectInspector)